import { UserManager, WebStorageStateStore } from "oidc-client";
import { AuthService } from "../auth/AuthService";

const createConfig = ({authority, clientId, baseUrl, logoutUri}) => {
    return {
        authority: authority,
        client_id: clientId,
        redirect_uri: `${baseUrl}/signin-oidc`,
        response_type: "code",
        scope: "openid profile",
        automaticSilentRenew: false,
        loadUserInfo: false,
        silent_redirect_uri: `${baseUrl}/renew-oidc`,
        post_logout_redirect_uri: logoutUri
    }
} 

const createUserManager = ({authority, clientId, baseUrl, logoutUri}) => new UserManager({
    ...createConfig({authority, clientId, baseUrl, logoutUri}),
    userStore: new WebStorageStateStore({ store: window.sessionStorage })
});

const getAccessToken = async ({authority, clientId, baseUrl, logoutUri}) => {
    var authService = new AuthService({authority, baseUrl, clientId, logoutUri});
    return authService.getAccessToken().then(access_token => {
        return access_token
    });
}

const getUser = async ({authority, clientId, baseUrl, logoutUri}) => {
    var authService = new AuthService({authority, baseUrl, clientId, logoutUri});
    return authService.getUser().then(user => {
        return user
    });
}

const userService = {
    createConfig,
    createUserManager,
    getAccessToken,
    getUser
}

export default userService